import React, { FC } from 'react';
import { TableDataItemKeyEnum } from '@api/business/treatmentHook/useForecastTool';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { Text } from '@components/Text/Text.component';
import { PlcColor } from '@styles/colors';

//import styles from './UiTable.module.scss'

export const UiTableHeadCells = Array.from({ length: 24 }, (_, k) => ({
  id: k as TableDataItemKeyEnum,
  label: `${k}h`,
}));

type UiTableHeaderProps = {
  setHoveredIndex: (value: number) => void;
  hoveredIndex?: number;
  isLoading: boolean;
};

const UiTableHeader: FC<UiTableHeaderProps> = ({ setHoveredIndex, hoveredIndex, isLoading }: UiTableHeaderProps) => (
  <thead>
    <tr>
      <td className={'table-left-item'} />
      {UiTableHeadCells.map((hc, i) => (
        <td
          align="right"
          className={'header-items'}
          key={hc.id}
          onMouseEnter={() => setHoveredIndex(i)}
          style={{ backgroundColor: hoveredIndex === i ? PlcColor.GREY_CLOUD_LIGHT : PlcColor.WHITE }}
        >
          {isLoading ? (
            <PlcTextListLoader textProps={[{ variant: 'h6', width: 20 }]} uniqueKey={`uiTableHead-${hc.id}`} />
          ) : (
            <Text tag="span" variant="h6">
              {hc.label}
            </Text>
          )}
        </td>
      ))}
    </tr>
  </thead>
);

export { UiTableHeader };
